import React from 'react';
import * as PropTypes from 'prop-types';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import Grid from '@material-ui/core/Grid';
import { AttachFile } from '@material-ui/icons';
import { IdPropType } from '../../../proptypes/basic';
import { useEmailDraft} from '../emailDraftsSlice';
import MailDraftContactsSlim from './MailDraftContactsSlim';

const DraftsListItem = ({ draftId, selected, onSelect }) => {
    const [draft] = useEmailDraft(draftId);

    if (!draft) {
        return null;
    }

    return (
        <ListItem onClick={() => onSelect(draft.id)} selected={selected} button divider>
            <ListItemText
                disableTypography
                primary={
                    <Grid container spacing={1} alignItems="flex-start" wrap="wrap">
                        <Grid item xs={6}>
                            <Typography variant="body2" color="textSecondary">
                                Email-Entwurf #{draft.id} Erstellt am{' '}
                                {new Date(draft.created_at).toLocaleDateString()}{' '}
                                {new Date(draft.created_at).toLocaleTimeString()}
                            </Typography>
                        </Grid>
                        <Grid item xs>
                            <MailDraftContactsSlim draftId={draftId} type={'to'} />
                        </Grid>
                        {draft && draft?.attachments?.length !== 0 && (
                            <Grid item>
                                <AttachFile fontSize="small" color="disabled" />
                            </Grid>
                        )}
                    </Grid>
                }
                secondary={
                    <>
                        <Typography variant="h5" color="textPrimary" gutterBottom>
                            {draft?.subject}
                        </Typography>
                    </>
                }
            />
        </ListItem>
    );
};

DraftsListItem.propTypes = {
    draftId: IdPropType.isRequired,
    selected: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
    folder: PropTypes.string,
};

DraftsListItem.defaultProps = {
    selected: false,
    folder: 'mail_inbox',
};

export default DraftsListItem;
